'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.Dialogs = Dialogs;
exports.closeDialog = closeDialog;
exports.openDialog = openDialog;
var modals = void 0;
var modalMap = void 0;

function Dialogs() {
    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

    var els = context.querySelectorAll('.js-dialog');

    modalMap = {};
    modals = Array.from(els).map(function (el, index) {
        modalMap[el.id] = index;

        el.addEventListener('click', function (evt) {
            if (evt.target.classList.contains('js-dialog-close') || evt.offsetX < 0 || evt.offsetX > evt.target.offsetWidth || evt.offsetY < 0 || evt.offsetY > evt.target.offsetHeight) {
                evt.preventDefault();
                closeDialog(el.id);
            }
        });

        return el;
    });

    document.addEventListener('click', function (evt) {
        if (evt.target.classList.contains('js-dialog-btn')) {
            openDialog(evt.target.getAttribute('aria-controls'));
        }
    });
}

function closeDialog(id) {
    if (typeof modalMap[id] === 'undefined') {
        console.warn('Modal with id of: ', id, ' was not found when closing');
        return;
    }

    var modal = modals[modalMap[id]];
    modal.close();
    document.body.classList.remove('fixed');
}

function openDialog(id) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (typeof modalMap[id] === 'undefined') {
        console.warn('Modal with id of: ', id, ' was not found when opening');
        return;
    }

    var modal = modals[modalMap[id]];
    if (!modal.open) {
        modal.showModal();
        document.body.classList.add('fixed');
    }

    if (callback) {
        var form = modal.querySelector('form');
        form.addEventListener('submit', function (evt) {
            evt.preventDefault();
            var formData = Array.from(new FormData(form).entries()).reduce(function (acc, _ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    key = _ref2[0],
                    value = _ref2[1];

                acc[key] = value;
                return acc;
            }, {});
            callback(formData);
            closeDialog(id);
        }, { once: true });
    }
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/ui/dialogs.js
// module id = ./resources/assets/js/src/ui/dialogs.js
// module chunks = 0